import React, { useEffect } from "react";
import { Switch } from "react-router-dom";
import { SecureRoute } from "@okta/okta-react";
import { useIdleTimer } from "@tailormed/common-client/services/idleTimer";
import { createStructuredSelector } from "reselect";
import { connect } from "react-redux";
import { Layout } from "antd";

import { MainView } from "../screen/MainView";
import { NewPatient } from "../screen/NewPatient";
import { Routes } from "../constant/routes";
import { EnvironmentHeader } from "../component/EnvironmentHeader";
import { PatientView } from "../screen/PatientView";
import { MainHeader } from "../component/MainHeader";
import { MainFooter } from "../component/MainFooter";
import { SearchResults } from "../screen/SearchResults";
import { RecentPatients } from "../screen/RecentPatients";
import { handleReturnFromSleep, renewTokenTimer } from "@tailormed/common-client/services/auth";
import { selectUser, selectIDPConfig } from "../store/selector";
import { oktaConfig } from "../constant/config";
import { FilterListView } from "../component/SavedList/FilterListView";
import { Content } from "antd/lib/layout/layout";

const HEADER_HEIGHT = 64;
const FOOTER_HEIGHT = 50;

const SecuredRouterComponent = ({ user, idpConfig }) => {
  useIdleTimer(user, idpConfig, oktaConfig.loginURI);

  useEffect(async () => {
    await renewTokenTimer(user, idpConfig, oktaConfig.loginURI);
    await handleReturnFromSleep(user, idpConfig, oktaConfig.loginURI);
  }, []);

  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <EnvironmentHeader />
        <MainHeader maxHeight={HEADER_HEIGHT} />
        <Content
          style={{
            background: "white",
            overflow: "auto",
            minHeight: `calc(100vh - ${HEADER_HEIGHT + FOOTER_HEIGHT}px)`
          }}
          id="content-id"
        >
          <Switch>
            <SecureRoute path={`${Routes.ROOT}:viewType/:filterListId/:savedListViewType`} exact>
              <FilterListView />
            </SecureRoute>
            <SecureRoute path={Routes.ROOT + Routes.NEW_PATIENT}>
              <NewPatient />
            </SecureRoute>
            <SecureRoute path={`${Routes.ROOT}${Routes.SEARCH_RESULTS}`}>
              <SearchResults />
            </SecureRoute>
            <SecureRoute path={`${Routes.ROOT}${Routes.RECENT_PATIENTS}`}>
              <RecentPatients />
            </SecureRoute>
            <SecureRoute path={`${Routes.ROOT}:viewType`}>
              <MainView />
            </SecureRoute>
            <SecureRoute path={Routes.ROOT}>
              <MainView />
            </SecureRoute>
            <SecureRoute exact path={"/"}>
              <MainView />
            </SecureRoute>
          </Switch>
        </Content>
        <PatientView />
        <MainFooter maxHeight={FOOTER_HEIGHT} />
      </Layout>
    </>
  );
};

const mapStateToProps = createStructuredSelector({
  user: selectUser,
  idpConfig: selectIDPConfig
});

const SecuredRouter = connect(mapStateToProps, null)(SecuredRouterComponent);
export { SecuredRouter };
